// ============================================
// CONPLANTAS — PÁGINA DE PRODUCTO
// ============================================

// URGENCY TIMER
// La lógica y los textos vienen de los ajustes globales del tema, resueltos por
// conplantas-countdown.js (window.cpCountdown).
function cpUpdateUrgency() {
  var block = document.querySelector('.cp-urgency-block');
  var icon  = document.getElementById('cpUrgIcon');
  var label = document.getElementById('cpUrgLabel');
  var timer = document.getElementById('cpUrgTimer');
  var desc  = document.getElementById('cpUrgDesc');
  if (!label || !timer || !window.cpCountdown) return;

  var state = window.cpCountdown.getState();

  if (!state.enabled) {
    if (block) block.style.display = 'none';
    return;
  }

  if (icon) icon.textContent = state.closed ? '🌙' : '⏰';
  label.textContent = state.label;
  timer.style.color = state.closed ? 'var(--cp)' : 'var(--cp-urgencia)';
  timer.textContent = window.cpCountdown.formatDuration(state.remainingMs);

  if (desc) {
    desc.textContent = state.desc;
    desc.appendChild(document.createElement('br'));
    var strong = document.createElement('strong');
    strong.id = 'cpUrgStrong';
    strong.textContent = state.window;
    desc.appendChild(strong);
  }
}

// GALLERY
function cpChangePhoto(url, el, srcset) {
  var thumbs = document.querySelectorAll('.cp-thumb');
  for (var i = 0; i < thumbs.length; i++) thumbs[i].classList.remove('active');
  el.classList.add('active');
  var main = document.getElementById('cpMainImg');
  if (!main) return;
  main.style.transition = 'opacity 0.2s';
  main.style.opacity = '0';
  var next = new Image();
  // Precarga con el mismo srcset/sizes para que el navegador elija la misma
  // resolución que luego pintará en la imagen principal.
  if (srcset) {
    next.srcset = srcset;
    next.sizes = main.sizes;
  }
  next.onload = function() {
    if (srcset) main.srcset = srcset;
    main.src = url;
    requestAnimationFrame(function() { main.style.opacity = '1'; });
  };
  next.src = url;
}

// VARIANT SELECTOR
function cpSelectVariant(el, variantId, variantName, price) {
  var swatches = document.querySelectorAll('.cp-variant-swatch');
  for (var i = 0; i < swatches.length; i++) swatches[i].classList.remove('selected');
  el.querySelector('.cp-variant-swatch').classList.add('selected');
  var nameEl = document.getElementById('cpVarSelected');
  if (nameEl) nameEl.textContent = variantName;
  var idInput = document.getElementById('cpVariantId');
  if (idInput) idInput.value = variantId;
  window.cpBasePrice = price;
  cpUpdatePriceDisplay();
}

// UPSELL
var cpExtras = 0;
var cpSelectedUpsells = new Set();

function cpToggleUpsell(el) {
  el.classList.toggle('selected');
  var price     = parseInt(el.dataset.price || 0);
  var variantId = el.dataset.variantId;
  var checkbox  = el.querySelector('.cp-upsell-checkbox');
  if (el.classList.contains('selected')) {
    checkbox.textContent = '✓';
    cpExtras += price;
    if (variantId) cpSelectedUpsells.add(variantId);
  } else {
    checkbox.textContent = '';
    cpExtras -= price;
    if (variantId) cpSelectedUpsells.delete(variantId);
  }
  cpUpdatePriceDisplay();
}

function cpUpdatePriceDisplay() {
  var total = (window.cpBasePrice || 0) + cpExtras;
  var fmt = new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(total / 100);
  var btnPrice = document.getElementById('cpCartBtnPrice');
  if (btnPrice) btnPrice.textContent = fmt;
  var sticky = document.getElementById('cpStickyPrice');
  if (sticky) sticky.textContent = fmt;
}

// ADD TO CART
document.addEventListener('DOMContentLoaded', function() {
  var form = document.getElementById('cp-product-form');
  if (!form) return;

  var cartBtnEl = document.getElementById('cpAddCartBtn');
  var cartBtnOriginalHTML = cartBtnEl ? cartBtnEl.innerHTML : '';

  form.addEventListener('submit', function(e) {
    var cartBtn = document.getElementById('cpAddCartBtn');

    if (cpSelectedUpsells.size > 0) {
      e.preventDefault();
      if (cartBtn) cartBtn.innerHTML = '⏳ Agregando complementos...';

      var items = [];
      cpSelectedUpsells.forEach(function(id) { items.push({ id: parseInt(id), quantity: 1 }); });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).catch(function(err) {
        console.error('Error al agregar complementos al carrito:', err);
      }).then(function() {
        form.submit();
      });
      return;
    }

    if (cartBtn) {
      var orig = cartBtn.innerHTML;
      cartBtn.innerHTML = '✓ ¡Agregado al carrito!';
      cartBtn.style.background = 'var(--cp-ambar)';
      setTimeout(function() {
        cartBtn.innerHTML = orig;
        cartBtn.style.background = '';
      }, 2000);
    }
  });

  // PEDIR AHORA
  var pedirBtn = document.getElementById('cpPedirAhoraBtn');
  if (pedirBtn) {
    var pedirOriginalText = pedirBtn.textContent;

    pedirBtn.addEventListener('click', function() {
      var orig = pedirOriginalText;
      pedirBtn.textContent = '⏳ Procesando...';
      pedirBtn.disabled = true;

      var addUpsells = Promise.resolve();
      if (cpSelectedUpsells.size > 0) {
        var items = [];
        cpSelectedUpsells.forEach(function(id) { items.push({ id: parseInt(id), quantity: 1 }); });
        addUpsells = fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      }

      var variantId = parseInt(document.getElementById('cpVariantId').value);
      var properties = {};

      // Campos de la app AJ Delivery Date
      var dateEl = document.getElementById('dds_calendar');
      var timeEl = document.getElementById('time-slot-options');
      var notaEl = document.getElementById('dds_calendar_notes');

      var dateVal = dateEl ? dateEl.value.trim() : '';
      var timeVal = timeEl ? timeEl.value.trim() : '';
      var notaVal = notaEl ? notaEl.value.trim() : '';

      if (dateVal) properties['Delivery Date'] = dateVal;
      if (timeVal) properties['Delivery Time'] = timeVal;
      if (notaVal) properties['Additional Comments'] = notaVal;

      addUpsells.then(function() {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1, properties: properties })
        });
      }).then(function() {
        window.location.href = '/checkout';
      }).catch(function(err) {
        console.error('Error en Pedir ahora:', err);
        pedirBtn.textContent = orig;
        pedirBtn.disabled = false;
      });
    });
  }

  // Al volver con el botón "atrás" del navegador la página se restaura desde el
  // bfcache tal cual quedó, con los botones congelados en su estado de carga.
  // pageshow es el único evento que dispara en esa restauración.
  window.addEventListener('pageshow', function(event) {
    if (!event.persisted) return;

    if (pedirBtn) {
      pedirBtn.textContent = pedirOriginalText;
      pedirBtn.disabled = false;
    }

    if (cartBtnEl) {
      cartBtnEl.disabled = false;
      cartBtnEl.style.background = '';
      cartBtnEl.innerHTML = cartBtnOriginalHTML;
      // El HTML original trae el precio base; los complementos siguen marcados
      // tras la restauración, así que hay que recalcular el total.
      cpUpdatePriceDisplay();
    }
  });
});

// ACCORDION
function cpToggleAccordion(header) {
  header.parentElement.classList.toggle('open');
}

// INIT
document.addEventListener('DOMContentLoaded', function() {
  cpUpdateUrgency();
  setInterval(cpUpdateUrgency, 1000);
});
